import fetch from 'utils/fetch';
const qs = require('qs')

const setContentType = (txt='application/x-www-form-urlencoded; charset=UTF-8') => {
	fetch.defaults.headers.post['Content-Type'] = txt
}

const sendRequire = (obj, txt) => {
	setContentType(txt)
	return fetch(obj)
}

//账号相关
const chooseAccount = (id) => sendRequire({
  url: '/choose',
  method: 'get',
  params: {id}
})
const login = () => sendRequire({
  url: '/login'
})
const logout = () => sendRequire({
  url: '/logout'
})
const getInfo = () => sendRequire({
  url: '/user_info'
})

//Promotor_manage_service
const promotorCreate = (data) => sendRequire({
	url: '/promotor/create',
	method: 'post',
	data: qs.stringify(data)
});

const promotorUpdate = (data) => sendRequire({
  url: '/promotor/update',
  method: 'post',
  data: qs.stringify(data)
});

const promotorLeaveJob = (promotorId) => sendRequire({
  url: '/promotor/leaveJob',
  method: 'post',
  data: qs.stringify({promotorId})
})

const promotorSearch = (data) => sendRequire({
  url: '/promotor/search',
  method: 'get',
  params: data
})

const promotorInfo = (id) => sendRequire({
  url: `/promotor/${id}`,
  method: 'get'
})

//订单管理
const orderMgmtOrder = (data) => sendRequire({
  url: '/orderMgmt/order',
  method: 'get',
  params: data
})

//订单管理
const orderMgmtLock = (data) => sendRequire({
  url: '/orderMgmt/lockOrderList',
  method: 'get',
  params: data
})

const orderMgmtChannel = () => sendRequire({
  url: '/orderMgmt/listOrderChannel',
  method: 'get'
})

const orderMgmtSubsite = () => sendRequire({
  url: '/orderMgmt/listSubsite',
  method: 'get'
})

const orderMgmtExport = () => sendRequire({
  url: '/orderMgmt/order/export',
  method: 'get'
})


//各销售数据
const opertionSummary = () => sendRequire({
  url: '/kpi/opertion_summary',
  method: 'get'
})

const subsiteSaleInfo = (data) => sendRequire({
  url: '/kpi/subsite_sale_info',
  method: 'get',
  params: data
})

const distributorSaleInfo = (data) => sendRequire({
  url: '/kpi/distributor_sale_info',
  method: 'get',
  params: data
})

const realtimeInfo = () => sendRequire({
  url: '/partner/realtime_info',
  method: 'get'
})

//有关子站
const subsiteList = (data) => sendRequire({
  url: '/partner/subsite_list',
  method: 'get',
  params: data
})

const subsiteSelectList = (data) => sendRequire({
  url: '/partner/subsite_select_list',
  method: 'get'
})

const subsiteConf = (data) => sendRequire({
  url: '/partner/subsite_conf',
  method: 'get',
  params: data
})

const createUpdateSubsite = (data) => sendRequire({
  url: '/partner/create_or_update_subsite',
  method: 'post',
  data: JSON.stringify(data)
}, 'application/json; charset=UTF-8')

const changeSubsiteName = (data) => sendRequire({
  url: '/partner/change_subsite_name',
  method: 'post',
  data: qs.stringify(data)
})

const addContentSub = (data) => sendRequire({
  url: '/partner/content_search',
  method: 'get',
  params: data
})

//合伙人/分销商后台-子站管理-分类设置中的分类列表
const partnerCategoryList = () => sendRequire({
  url: '/partner/category_list',
  method: 'get'
})

// 图片上传
const fileUpload = (url,data) => sendRequire({
  url: url,
  method: 'post',
  data: data
},'Multipart/form-data')

// 合伙人通知
const partnerNotice = () => sendRequire({
  url: '/announcement',
  method: 'get'
})
const notifyAll = () => sendRequire({
  url: '/notify/all',
  method: 'get'
})
const notifyList = (data) => sendRequire({
  url: '/notify/list',
  method: 'get',
  params:data
})
const notifyRead = (data) => sendRequire({
  url: '/notify/read',
  method: 'get',
  params:data
})
//活动通知
const ActnotifyList = (data) => sendRequire({
  url: '/activity/notify/list',
  method: 'get',
  params:data
})

//子站专辑
const subsiteAlbumList = (data) => sendRequire({
  url: '/partner/subsite_album_list',
  method: 'get',
  params: data
})

//子站声音
const subsiteTrackList = (data) => sendRequire({
  url: '/partner/subsite_track_list',
  method: 'get',
  params: data
})

// 子站分类置顶专辑信息（user's）
const userAlbumStick = (params) => sendRequire({
  url: '/partner/subsite_category_album_list',
  method: 'get',
  params
})

// 子站分类置顶专辑信息（init）
const initAlbumList = (params) => sendRequire({
  url: '/partner/content_search_by_category',
  method: 'get',
  params
})

// 子站分类置顶专辑信息（search）
const albumSearch = (params) => sendRequire({
  url: '/partner/content_search',
  method: 'get',
  params
})

// 数据中心-用户增长详情
const incrementData = () => sendRequire({
  url: '/report/active/index',
  method: 'get'
})

// 数据中心-用户增长详情-折线图(日期跨度)数据速查
const chartRegionData = (params) => sendRequire({
  url: '/report/active/choose',
  method: 'get',
  params
})

// 数据中心-用户增长详情-表格(日期跨度)数据速查
const tableRegionData = (params) => sendRequire({
  url: '/report/active/search',
  method: 'get',
  params
})

// 数据中心-用户增长详情-表格导出excel
const exportTable = (params) => sendRequire({
  url: '/report/active/export',
  method: 'get',
  params
})

// 数据中心-专辑排行-获取城市列表
const getRankCity = () => sendRequire({
  url: '/report/my/city',
  method: 'get'
})

// 数据中心-专辑排行-获取分类
const getRankClassify = () => sendRequire({
  url: '/report/all/category',
  method: 'get'
})

// 数据中心-专辑排行-获取排行列表
const getRanking = (data) => sendRequire({
  url: '/report/album/ranking',
  method: 'post',
  data: qs.stringify(data)
})

// 数据中心-专辑排行-获取排行列表
const searchRanking = (data) => sendRequire({
  url: '/report/album/search',
  method: 'post',
  data: qs.stringify(data)
})

// 数据中心-锁定用户详情
const lockDetail = (params) => sendRequire({
  url: '/lock/detail/list',
  method: 'get',
  params
})

// 数据中心-分销商锁定用户详情
const lockPromotorDetail = (params) => sendRequire({
  url: '/lock/detail/promotor/list',
  method: 'get',
  params
})

// 数据中心-授权手机号用户
const authMobile = (params) => sendRequire({
  url: '/kpi/partner_listen_book_list',
  method: 'get',
  params
})

// 极光账号信息
const auroraAccounts = (params) => sendRequire({
  url: '/aurora/accounts',
  method: 'get',
  params
})

const recent = () => sendRequire({
  url: '/notify/recent',
  method: 'get'
});

// 获取预付款相关信息
const getAccountInfo = () => sendRequire({
  url: '/imprest/balance',
  method: 'get'
});
const getAccountList = (params) => sendRequire({
  url: '/imprest/flowList',
  method: 'get',
  params
});
const getRechargeList = (params) => sendRequire({
  url: '/imprest/rechargeList',
  method: 'get',
  params
});
const postRechargeApply = (params) => sendRequire({
  url: '/imprest/recharge',
  method: 'post',
  params
});
export {
  //账号相关
  chooseAccount, login, logout, getInfo,

	//Promotor_manage_service
	promotorCreate, promotorUpdate, promotorLeaveJob, promotorSearch, promotorInfo,

	//order
	orderMgmtOrder, orderMgmtLock, orderMgmtChannel, orderMgmtSubsite, orderMgmtExport,

	//get data 销售数据
	opertionSummary, subsiteSaleInfo, distributorSaleInfo, realtimeInfo, auroraAccounts,

	//有关子站
	subsiteList, subsiteAlbumList, subsiteTrackList, subsiteSelectList, subsiteConf, createUpdateSubsite, changeSubsiteName,
  //子站多图
  fileUpload, addContentSub,
  //子站分类置顶专辑信息
  userAlbumStick, initAlbumList, albumSearch,

  //分类
  partnerCategoryList,

  //合伙人通知
  partnerNotice, notifyAll,notifyList,notifyRead,

  //活动通知
  ActnotifyList,

  //数据中心
  incrementData, chartRegionData, tableRegionData, exportTable,

  getRankCity, getRankClassify, getRanking, searchRanking,

  lockDetail, lockPromotorDetail, authMobile,

  //通知中心
  recent,

  // 预付款
  getAccountInfo, getAccountList, getRechargeList, postRechargeApply
}




// WEBPACK FOOTER //
// ./src/api/index.js